import { AxiosResponse } from 'axios'
import firebase from 'firebase/compat/app'
import { RemoteConfig } from 'firebase/remote-config'
import { createContext } from 'react'

import { GetVariable, GetVariableValue } from '../hooks'
import { AnyVariable, InputParameter, VariableSource } from '../utils'

export type FGP = (getVariableValue: GetVariableValue, parameters: InputParameter[]) => Promise<void>

export type FGV = (getVariableValue: GetVariableValue, variable: AnyVariable) => Promise<void>

export type FGVR = (getVariableValue: GetVariableValue, variable: AnyVariable, resend?: boolean) => Promise<void>

export type FNDA = (
  name: string,
  data?: { [key: string]: any },
  asynchronous?: boolean
) => Promise<AxiosResponse<any, any>>

export type FGPV = (
  getVariableValue: GetVariableValue,
  parameters: InputParameter[],
  valueTarget: VariableSource
) => Promise<void>

export type FGF = (getVariableValue: GetVariableValue, file: File) => Promise<unknown>

export type FGPID = (getVariable: GetVariable, priceId: string) => Promise<unknown>

export interface F {
  version: string
  firestorePrefix: string
  auth: firebase.auth.Auth
  firestore: firebase.firestore.Firestore
  remoteConfig: RemoteConfig
  getRemoteConfigValue: (key: string) => string
  signInWithGoogle: () => Promise<void>
  createUserWithEmailAndPassword: FGP
  signInWithEmailAndPassword: FGP
  sendPasswordResetEmail: FGV
  sendSignInLinkToEmail: FGVR
  reSendSignInLinkToEmail: FGV
  checkNotificationsEnabled: () => Promise<boolean>
  enableNotifications: () => Promise<void>
  logout: () => Promise<void>
  runFlow: FNDA
  search: (url: string) => Promise<AxiosResponse<any, any>>
  oauth: FGPV
  checkoutSelected: FGPID
  restorePurchases: () => Promise<unknown>
  getAssetRecord: FGF
  getStripePriceDetails: (priceId: string) => Promise<unknown>
  emailKey: string
}

export const FirebaseContext = createContext<{ f: F }>({
  f: {
    version: '',
    firestorePrefix: '',
    auth: {} as firebase.auth.Auth,
    firestore: {} as firebase.firestore.Firestore,
    remoteConfig: {} as RemoteConfig,
    getRemoteConfigValue: () => '',
    signInWithGoogle: async () => {},
    createUserWithEmailAndPassword: async () => {},
    signInWithEmailAndPassword: async () => {},
    sendPasswordResetEmail: async () => {},
    sendSignInLinkToEmail: async () => {},
    reSendSignInLinkToEmail: async () => {},
    checkNotificationsEnabled: async () => false,
    enableNotifications: async () => {},
    logout: async () => {},
    runFlow: () => ({}) as Promise<AxiosResponse<any, any>>,
    search: async () => ({}) as Promise<AxiosResponse<any, any>>,
    oauth: async () => {},
    checkoutSelected: async () => {},
    restorePurchases: async () => {},
    getAssetRecord: async () => {},
    getStripePriceDetails: async () => {},
    emailKey: '',
  },
})

export * from './FirebaseProvider'
